import React, { useEffect } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { authSelector, checkUserToken } from '../../Auth/authSlice';
import PrivateRoute from '../PrivateRoute';
import Dashboard from '../../Dashboard/index';
import AllProcess from '../../Process/index';
import ViewAllProcess from '../../ViewAllProcess/index'
import ManageTemplates from '../../Templates/index';
import ViewTemplate from '../../ViewTemplates/index';
import NewTemplate from '../../NewTemplate/index';
import EditTemplate from '../../EditTemplate/index';
import EditTemplateDraft from '../../EditTemplateDraft/index';
import Departments from '../../Department/index';
import AddDepartment from '../../AddDepartment/index';
import EditDepartment from '../../EditDepartment/index';
import ViewDepartment from '../../ViewDepartment/index';
import AddBranch from '../../AddBranch/index';
import ViewEditBranch from '../../ViewEditBranch/index';
import AddOffice from '../../AddOffice/index';
import ViewEditOffice from '../../ViewEditOffice/index';
import AddDirectorate from '../../AddDirectorate';
import ViewEditDirectorate from '../../ViewEditDirectorate/index';
import UserRoles from "../../UserRoles/index";
import AddRole from "../../AddRole/index";
import EditRole from "../../EditRole/index";
import ManageUser from '../../ManageUser/index';
import SubAdmin from "../../SubAdmin/index";
import AddSubAdmin from "../../AddSubAdmin/index"
import EditSubAdmin from '../../EditSubAdmin/index';
import ViewSubAdmin from '../../ViewSubAdmin/index';
import AddUser from '../../AddUser/index';
import EditUser from '../../EditUser/index';
import ViewAllUser from '../../ViewAllUser/index';
import ViewUser from '../../ViewUser';

import DistributionList from '../../DistributionList/DistributionList';
import AddDistributionList from '../../DistributionList/AddDistributionList';

import DocumentVerification from '../../DocumentVerification/DocumentVerification';
import DocumentSignature from '../../DocumentSignature/index';

import ManageActivity from '../../ManageActivity/index';

import ability from '../../../config/ability';

export default function AdminRoutes() {

  const dispatch = useDispatch();
  let history = useHistory();

  const { isLoggedIn, user } = useSelector(
    authSelector
  );

  useEffect(() => {
    dispatch(checkUserToken()).then((res) => {
      if (res.message === "unauthorized") { history.push('/'); }
    }).catch((err) => {
      // console.log("err=>   ", err)
    });
  }, [])

  return (
    <>
      {user.userType == 'admin' || user.userType == 'subAdmin'
        ? <>
          <PrivateRoute path="/dashboard" component={Dashboard} />
          {ability.can('allProcessTab', 'viewOnGoingProcess') &&
            <PrivateRoute path="/all-seen-stamp" component={AllProcess} exact />
          }

          {/* {ability.can('departmentTab', 'viewOnlyDepartments') &&
          <PrivateRoute path="/departments" component={Departments} exact />
      } */}

          <PrivateRoute path="/departments" component={Departments} exact />

          {ability.can('userRolesTab', 'viewOnlyRoles') &&
            <PrivateRoute path="/appointments" component={UserRoles} exact />
            // <PrivateRoute path="/user-roles" component={UserRoles} exact />
          }

          {ability.can('manageUsersTab', 'viewOnlyUsers') &&
            <PrivateRoute path="/manage-users" component={ManageUser} exact />
          }
          {/* <PrivateRoute path="/all-seen-stamp" component={AllProcess} exact /> */}
          <PrivateRoute path="/distribution-list" component={DistributionList} exact />
          <PrivateRoute path="/add-distribution-list" component={AddDistributionList} exact />
          <PrivateRoute path="/view-all-seen-stamp" component={ViewAllProcess} exact />
          <PrivateRoute path="/manage-seen-stamp" component={ManageTemplates} exact />
          <PrivateRoute path="/view-seen-stamp" component={ViewTemplate} exact />
          <PrivateRoute path="/new-seen-stamp" component={NewTemplate} exact />
          <PrivateRoute path="/edit-seen-stamp" component={EditTemplate} exact />
          <PrivateRoute path="/edit-seen-stamp-draft" component={EditTemplateDraft} exact />
          {/* <PrivateRoute path="/departments" component={Departments} exact /> */}
          <PrivateRoute path="/add-department" component={AddDepartment} exact />
          <PrivateRoute path="/edit-department" component={EditDepartment} exact />
          <PrivateRoute path="/view-department" component={ViewDepartment} exact />
          <PrivateRoute path="/add-branch" component={AddBranch} exact />
          <PrivateRoute path="/view-branch" component={ViewEditBranch} exact />
          <PrivateRoute path="/view-office" component={ViewEditOffice} exact />
          <PrivateRoute path="/add-office" component={AddOffice} exact />
          <PrivateRoute path="/add-directorate" component={AddDirectorate} exact />
          <PrivateRoute path="/view-independent-directorate" component={ViewEditDirectorate} exact />
          {/* <PrivateRoute path="/user-roles" component={UserRoles} exact /> */}
          {/* <PrivateRoute path="/add-role" component={AddRole}  exact />
      <PrivateRoute path="/edit-role" component={EditRole}  exact /> */}
          <PrivateRoute path="/add-appointment" component={AddRole} exact />
          <PrivateRoute path="/edit-appointment" component={EditRole} exact />
          {/* <PrivateRoute path="/manage-users" component={ManageUser} exact /> */}
          <PrivateRoute path="/add-user" component={AddUser} exact />
          <PrivateRoute path="/edit-user" component={EditUser} exact />
          <PrivateRoute path="/view-all-user" component={ViewAllUser} exact />
          <PrivateRoute path="/view-user" component={ViewUser} exact />

          <PrivateRoute path="/verify-document" component={DocumentVerification} exact />
          <PrivateRoute path="/document-signin" component={DocumentSignature} exact />
          <PrivateRoute path="/manage-activity" component={ManageActivity} />
          {user.userType == 'admin' &&
            <>
              <PrivateRoute path="/sub-admin" component={SubAdmin} exact />
              <PrivateRoute path="/add-sub-admin" component={AddSubAdmin} exact />
              <PrivateRoute path="/edit-sub-admin" component={EditSubAdmin} exact />
              <PrivateRoute path="/view-sub-admin" component={ViewSubAdmin} exact />
            </>
          }

        </>
        : <Redirect to="/login" />
      }

    </>
  );
}


